import styled from 'styled-components';

export default styled.div`
  && {
    .svg-success {
      text-align: center;
      margin-top: 75px;
    }
    .register-success {
      color: #80a445;
      text-align: center;
      margin-top: 50px;
    }
    .detail-register {
      text-align: center;
      margin-top: 83px;
      .btn-detail-register {
        width: 338px;
        height: 60px;
        background: #ff8a00;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
        color: white;
        text-align: center;
      }
    }
  }
`;
